import { Input } from "@themes/pollinator/ui/Input";
import { Label } from "@themes/pollinator/ui/Label";
import { SubStepLayout } from "@platform/features/onboarding/components/SubStepLayout";

export type Props = {
  /** Current website value */
  website: string;
  /** Handler when website value changes */
  onWebsiteChange: (value: string) => void;
  /** Handler for continue/next button */
  onContinue: () => void;
  /** Handler for back button (hidden if undefined) */
  onBack?: () => void;
  /** Handler for skip button (hidden if undefined) */
  onSkip?: () => void;
  /** Current step index (0-indexed) */
  stepIndex: number;
  /** Total steps */
  totalSteps: number;
};

/**
 * Presentational website input sub-step for profile onboarding.
 * Renders a website URL input within the sub-step layout.
 */
export function WebsiteSubStep({
  website,
  onWebsiteChange,
  onContinue,
  onBack,
  onSkip,
  stepIndex,
  totalSteps,
}: Props) {
  return (
    <SubStepLayout
      title="Add Your Website"
      description="Share your personal or professional website with your peer circle."
      stepIndex={stepIndex}
      totalSteps={totalSteps}
      onPrimaryClick={onContinue}
      onBack={onBack}
      onSkip={onSkip}
    >
      <div className="flex flex-col gap-2">
        <Label htmlFor="website" id="website-label">
          Website URL
        </Label>
        <Input
          id="website"
          name="website"
          type="url"
          value={website}
          onChange={(e) => onWebsiteChange(e.target.value)}
          placeholder="https://yourwebsite.com"
          aria-labelledby="website-label"
        />
      </div>
    </SubStepLayout>
  );
}

export default WebsiteSubStep;
